import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { AppSelectionComponent } from './components/app-selection/app-selection.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  // { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'app-selection', component: AppSelectionComponent,
  canActivate: mapToCanActivate([AuthGuard]) },
  // { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**',   redirectTo: '/login' } //Should stay last
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
